import '../../styles/LoadingAnimation.css';
import * as React from "react";

export default function MaiaDotsLoader() {
  return (
    <div className="loading-dots"></div>
  );
}